"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _docsHttpClient = _interopRequireWildcard(require("@adsk/docs-http-client"));
var _consts = require("./consts");
var _file = require("./file");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var isOssRetryError = function isOssRetryError(error) {
  return error && error.response && [400, 404, 408, 409, 429, 500, 503, 504].includes(error.response.status);
};
var DEFAULT_RETRY_CONFIG = {
  shouldResetTimeout: true,
  retries: _consts.DEFAULT_RETRY_TIMES,
  retryDelay: function retryDelay(retryCount) {
    return Math.pow(retryCount, 3) * 1000;
  },
  // 1s 8s 27s
  retryCondition: function retryCondition(error) {
    return _docsHttpClient.axiosRetry.isNetworkError(error) || _docsHttpClient.axiosRetry.isSafeRequestError(error) || isOssRetryError(error);
  }
};
var _default = exports["default"] = function _default(config) {
  var ossBaseUrl = config.baseURL || _consts.OSS_BASE_URL[config.env || _consts.OSS_ENVS.STAGING];
  var Services = {
    OSS_V2: new _docsHttpClient["default"](Object.assign({}, config, {
      baseURL: "".concat(ossBaseUrl).concat(_consts.OSS_BASE_PATH),
      withToken: config.getAccessToken ? true : false,
      getToken: config.getAccessToken,
      retryConfig: config.retryConfig || DEFAULT_RETRY_CONFIG
    })),
    AWS_S3: new _docsHttpClient["default"](Object.assign({}, config, {
      baseURL: '',
      withToken: false,
      retryConfig: config.retryConfig || DEFAULT_RETRY_CONFIG,
      // Disabled circuit breaker for AWS S3 by default
      circuitBreaker: {
        disabled: true
      }
    }))
  };
  var getSignedUrl = function getSignedUrl(_ref, options) {
    var bucketKey = _ref.bucketKey,
      objectKey = _ref.objectKey,
      uploadKey = _ref.uploadKey,
      firstPart = _ref.firstPart;
    var path = (0, _file.getSignedUrlPath)({
      bucketKey: bucketKey,
      objectKey: objectKey,
      uploadKey: uploadKey,
      firstPart: firstPart,
      parts: 1,
      minutesExpiration: _consts.S3_URL_EXPIRED_DURATION
    }); // only get one part url
    return Services.OSS_V2.get(path, options);
  };
  var putToSignedUrl = function putToSignedUrl(signedUrl, data, callback, options) {
    return Services.AWS_S3.put(signedUrl, data, Object.assign({
      onUploadProgress: function onUploadProgress(event) {
        callback({
          totalBytes: event.total,
          uploadedBytes: event.loaded
        });
      }
    }, options));
  };
  var completeUpload = function completeUpload(_ref2, options) {
    var bucketKey = _ref2.bucketKey,
      objectKey = _ref2.objectKey,
      uploadKey = _ref2.uploadKey;
    var path = "/buckets/".concat(bucketKey, "/objects/").concat(objectKey, "/signeds3upload");
    return Services.OSS_V2.post(path, {
      uploadKey: uploadKey
    }, options);
  };
  var deleteFile = function deleteFile(objectId, options) {
    var bucketKey = (0, _file.getBucketKeyFromObjectId)(objectId);
    var objectKey = (0, _file.getObjectKeyFromObjectId)(objectId);
    var path = "/buckets/".concat(bucketKey, "/objects/").concat(objectKey);
    return Services.OSS_V2["delete"](path, options);
  };
  return {
    getSignedUrl: getSignedUrl,
    putToSignedUrl: putToSignedUrl,
    completeUpload: completeUpload,
    deleteFile: deleteFile
  };
};